var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1 16.97C35.1 7.597 27.243 0 17.55 0 7.857 0 0 7.597 0 16.97c0 9.372 7.857 16.969 17.55 16.969 9.693 0 17.55-7.597 17.55-16.97Zm-7.02 9.545h-6.581l-5.503-7.255-7.002 7.255H7.02l8.108-8.4L7.02 7.425h6.581l5.212 6.872 6.634-6.873h1.975l-7.74 8.018 8.398 11.073Zm-5.447-1.06h2.7L12.468 8.484H9.765l12.866 16.97h.001Z",
    fill: "#2C112D"
  })));
};
export default SvgTwitter;